export function isDebugRequested(
  query: Record<string, string | string[] | undefined> | undefined,
): boolean {
  return query?.debug === 'true';
}
